export default __webpack_public_path__ + "static/CCDE_desktop_1440x480-446658e2525476c6852f31204f2e3259.jpg";